import { render } from "./OrderSummary.vue?vue&type=template&id=2dfc3a4d"
import script from "./OrderSummary.vue?vue&type=script&lang=js"
export * from "./OrderSummary.vue?vue&type=script&lang=js"

import "./OrderSummary.vue?vue&type=style&index=0&id=2dfc3a4d&lang=scss"
script.render = render

export default script